module.exports = __webpack_public_path__ + "img/case_icon.aec8e6d3.svg";